<template>
  <div >
    <BackgroundImage/>

    <FinalSphere
      ref="childComponent"
      :roomConnection="roomConnection"
      :reRenderRoom="reRenderRoom"
      :cameraOptions="cameraOptions"
      :geolocation="geolocation"
      :reRenderRemoteAudio="reRenderRemoteAudio"
    />

    <ButtonMenu>
        <ToggleButton
          @toggled="toggel"
          componentType="camera"
        >Camera
        </ToggleButton>

        <ToggleButton
          @toggled="toggel"
          componentType="microphone"
        >Microphone
        </ToggleButton>

        <!-- <ToggleButton
          @toggled="toggel"
          componentType="location"
        >Location
        </ToggleButton> -->

    </ButtonMenu>

    <Geolocation
      ref="location"
      :username="username"
      :activeRoom="roomConnection"
      @coords="newcoords"
    />


    <!-- <div class="todo">
    <ul>
      
      <li class ="done"> BackgroundImage</li>      

      <li class="done">Sphere</li>
      <ul>
        <li class="done">Css canvas</li>
        <li class="done">webGL canvas</li>

        <li class="done">sphere </li>
        <li class="done">video & audio</li>
      </ul>

      <li>Buttons</li>
      <ul>
        <li class="done">turn on camera </li>
        <li class="done">turn turn on location</li>
      </ul>

      <li>de locatie aan de sphere verbinden</li>
      <li>verbinding maken met de api voor de texture</li>
      <li>informatie button</li>
    </ul>

  </div> -->
    
  </div>
</template>

<script>
import BackgroundImage from '../BackgroundImage';
import FinalSphere from './FinalSphere'
import ToggleButton from './ToggleButton'
import ButtonMenu from './ButtonMenu'
import Geolocation from './Geolocation'
export default {

  data(){
    return{
      cameraButtonDisabled:false,
      geolocation:null
    }
  },

  components: {
    BackgroundImage,
    FinalSphere,
    ToggleButton,
    ButtonMenu,
    Geolocation

  },


  props: ["roomConnection","roomObject","reRenderRoom","cameraOptions","username","reRenderRemoteAudio"],

  mounted() {
  },

  created(){
  },


  methods: {

    cameraToggle(e){
      this.$refs.childComponent.turnOnCamera();
    },

    toggel(e){

      if(e == "camera"){
        this.$refs.childComponent.turnOnCamera();
      }

      if(e == 'microphone'){
        this.$refs.childComponent.turnOnMic();
      }

      if(e == "location"){
        this.$refs.location.locateMe();
      }

    },

    newcoords(e){
      console.log(e)
      this.geolocation = e;
      // console.log(this.roomConnection);

    }


  }

}
</script>

<style>


.todo{
  text-align: left;
  position: fixed;
  top: 10%;
  left: 2%;
  color: salmon;
  background-color:white;
  font-family: Helvetica, Arial, sans-serif;
  padding-right:20px;
}

.done{
  text-decoration: line-through;

}




</style>